<template>
    <ExperienceHub/>
</template>

<script>
import ExperienceHub from '@/components/experienceHub/ExperienceHub.vue';

export default {
    name: 'ExperienceHubPrincipal',
    components:{
        ExperienceHub
    }
}
</script>
